export default "__VITE_ASSET__CFkADiiZ__"